import React from 'react';
import { ResultModal } from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultModal.styles';
import {
  RiskCardStyles, LeftCol, LogoPriceContainer, LogoContainer, PriceContainer, Price, QuoteInformationContainer, QuoteInformationItem, RightCol, AquistaButtonsContainer, AquistaButton,
} from '../../../common/components/redesignComponents/ResultPageComponents/v2/RiskCard.styles';
import TravelInfortuniGuaranteeModal from '../../../common/components/redesignComponents/Modal/TravelInfortuniGuaranteeModal';
import { BACKEND_BASE_URL } from '../../../config';
import { confirmAlert } from '../../../common/utils/alerts';

function TravelCoverageModal({
  coverage,
  addingQuote,
  processingQuote,
  getCoveragePrice,
  handleGuarantees,
  loadingDataset,
  formData,
  register,
  updateDataSet,
}) {
  return (
    <ResultModal
      className="modal fade"
      id={`id_${coverage.coverage_id}`}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              <h5>{coverage.title}</h5>
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id={`id_${coverage.coverage_id}_button`}
            />
          </div>
          <div className="modal-body">
            {addingQuote && (
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">
                      Aggiungendo...
                    </span>
                  </div>
                </div>
                <div className="ms-2">Aggiungendo...</div>
              </div>
            )}
            <div className="row purchase-quote-eight-step p-1">
              <RiskCardStyles>
                <LeftCol>

                  <LogoPriceContainer>
                    <LogoContainer>
                      <img
                        src={BACKEND_BASE_URL + processingQuote.company.logo}
                        alt={`${processingQuote.company.name} Logo`}
                      />
                    </LogoContainer>
                    <PriceContainer>
                      <Price>
                        <h5>Prezzo annuo:</h5>
                        <h2>
                          €
                          {parseFloat(getCoveragePrice(coverage)).toFixed(2)}
                        </h2>
                      </Price>
                    </PriceContainer>
                  </LogoPriceContainer>

                  <QuoteInformationContainer>
                    <QuoteInformationItem>
                      <h6>Prodotto:</h6>
                      <p>{processingQuote.quotation_data_travel_europeassistance.product_name}</p>
                    </QuoteInformationItem>
                    <QuoteInformationItem>
                      <h6>
                        {coverage.title}
                        :
                      </h6>
                      <p>{coverage.limit_desc}</p>
                    </QuoteInformationItem>

                    {processingQuote.quotation_data_travel_europeassistance.coverages.filter((c) => c.group_id !== null && c.group_id === coverage.group_id && c.coverage_id !== coverage.coverage_id).map((cov, index) => (
                      <QuoteInformationItem key={index}>
                        <h6>
                          {cov.title}
                          :
                        </h6>
                        <p>{cov.limit_desc}</p>
                      </QuoteInformationItem>
                    ))}

                  </QuoteInformationContainer>
                </LeftCol>
                <RightCol>
                  {(coverage.coverage_id === '000001_EA1358' || coverage.coverage_id === '000001_EA1244')
                    && (
                      <TravelInfortuniGuaranteeModal
                        loadingDataset={loadingDataset}
                        formData={formData}
                        register={register}
                        updateDataSet={updateDataSet}
                      />
                    )}

                  <AquistaButtonsContainer>

                    <AquistaButton
                      onClick={() => confirmAlert('Sei sicuro di aggiungere questa garanzia?', () => handleGuarantees(coverage.coverage_id, `id_${coverage.coverage_id}_button`))}

                    >
                      Seleziona
                    </AquistaButton>
                  </AquistaButtonsContainer>
                </RightCol>
              </RiskCardStyles>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger px-4"
              data-bs-dismiss="modal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default TravelCoverageModal;
